import { animate } from 'animejs';

const fadeIn = (onBegin, onComplete) => {
  animate(document.querySelector('.loadScreen'), {
    ease: 'linear',
    opacity: [1, 0],
    onBegin: () => {
      if (onBegin) {
        onBegin();
      }
    },
    onComplete: () => {
      document.querySelector('.loadScreen').style.display = 'none';
      if (onComplete) {
        onComplete();
      }
    },
  });
};

const fadeOut = (onComplete) => {
  animate(document.querySelector('.loadScreen'), {
    ease: 'linear',
    opacity: [0, 1],
    onBegin: () => {
      document.querySelector('.loadScreen').style.display = 'block';
    },
    onComplete: () => {
      if (onComplete) {
        onComplete();
      }
    },
  });
};

export { fadeIn, fadeOut };
